import VenueBookingForm from '@/components/public/services/venue-booking/VenueBookingForm';
import ServiceRequestLayout from '@/components/public/services/ServiceRequestLayout';

export default function VenueBooking() {
  return (
    <ServiceRequestLayout
      seoTitle="Reserva de Espaço"
      seoDescription="Reserve salões, pavilhões e campos desportivos da freguesia para os seus eventos e atividades comunitárias."
      badge="Serviços ao Cidadão"
      breadcrumbs={[
        { label: 'Serviços', href: '/services' },
        { label: 'Aluguer de Espaços e Equipamentos' },
      ]}
      title="Aluguer de Espaços e Equipamentos."
      accentWord="Espaços e Equipamentos."
      subtitle="Reserve salões, pavilhões e campos desportivos da freguesia para os seus eventos e atividades comunitárias."
      panelTitle="Pedido de Aluguer"
      panelIntro="Preencha o formulário com os detalhes do seu evento. A confirmação da disponibilidade será comunicada assim que possível."
    >
      <VenueBookingForm />
    </ServiceRequestLayout>
  );
}
